import { FC } from 'react';
import { Container, IconContainer, TextContainer } from './ReportEmptyState.styles';
import { AllieText } from '../../../../../components/Text';
import { AllieFileSearchIcon } from '../../../../../styling/icons';

interface ReportEmptyStateProps {
  title: string;
  description: string;
}

export const ReportEmptyState: FC<ReportEmptyStateProps> = ({ title, description }) => {
  return (
    <Container>
      <IconContainer>
        <AllieFileSearchIcon 
          style={{ 
            width: '24px', 
            height: '24px',
            color: 'var(--allie-color-neutral-90)'
          }} 
        />
      </IconContainer>
      <TextContainer>
        <AllieText type="body1" weight={700} color="neutral-90">
          {title}
        </AllieText>
        <AllieText type="body2" weight={400} color="neutral-60">
          {description}
        </AllieText>
      </TextContainer>
    </Container>
  );
};
